import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { apiRoute, stateEnum } from "../constants/enum";
const { catalogEntry } = stateEnum

const initialState = {
    isNewEntry: true,
    detailParams: []
}

const catalogEntrySlice = createSlice({
    name: catalogEntry,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        resetDetailParams: (state) => {
            state.detailParams = []
            state.isNewEntry = true
        },
        setDetailParams: (state,action) => {
            state.detailParams = action.payload
        },
    },
})

export const{setNewEntryMode,resetDetailParams,setDetailParams}=catalogEntrySlice.actions
export default catalogEntrySlice.reducer